<div class="auth-page-container min-h-screen flex items-center justify-center relative">
  <!-- Background image container -->
  <div class="auth-background absolute inset-0 z-0"></div>
    <!-- Auth content container -->
  <div class="auth-content-wrapper z-10 w-full max-w-md px-4">
    <div class="auth-card bg-neutral-950 rounded-lg shadow-xl overflow-hidden">
      <!-- Router outlet for auth components -->
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
